import { FC, useRef } from 'react';
import './DocumentTabItem.scss';
import FormBuilder from '@molecules/formbuilder/FormBuilder';
import { IDocumentData } from '@models/document/IDocumentData';
import { UseFormReturn } from 'react-hook-form';
import { IDocumentBlock } from '@models/Forms/IForms';
import { IFieldElem } from '@models/IFormData';
import { IDocumentScheme } from '@models/document/IDocumentScheme';
import ScrollToTop from '@srm/ui/scroll-to-top';
import { EnsureExternalDataSourceLoaded } from '@/utils/externalDataSourceUtils';
import { DocumentFormulaTraceParentContext, formulaTraceAttrs } from '@/context/DocumentFormulaTraceContext';

export interface IDocumentTabItem {
    tab: IDocumentBlock;
    scheme: IDocumentScheme;
    isNew: boolean;
    isEdit: boolean;
    formMethods: UseFormReturn<IDocumentData>;
    setError: (errors?: string[]) => void;
    fields: Record<string, IFieldElem>;
    includedFields: number[];
    docId: string;
    turnOffInvokeChangesOnNew: boolean;
    ensureExternalDataSourceLoaded?: EnsureExternalDataSourceLoaded;
}

const DocumentTabItem: FC<IDocumentTabItem> = ({
    tab,
    scheme,
    isNew,
    isEdit,
    formMethods,
    setError,
    fields,
    includedFields,
    docId,
    turnOffInvokeChangesOnNew,
    ensureExternalDataSourceLoaded,
    ...props
}: IDocumentTabItem) => {
    const documentTabRef = useRef<HTMLDivElement>(null);

    const traceTarget = { targetId: `page-${tab.id}`, targetKind: 'tab' as const };

    return (
        <DocumentFormulaTraceParentContext value={traceTarget}>
            <div
                className="doc-tab"
                ref={documentTabRef}
                {...formulaTraceAttrs(traceTarget.targetId, traceTarget.targetKind)}
                {...props}
            >
                <FormBuilder
                    block={tab}
                    docId={docId}
                    setError={setError}
                    isEdit={isEdit}
                    isNew={isNew}
                    turnOffInvokeChangesOnNew={turnOffInvokeChangesOnNew}
                    formMethods={formMethods}
                    fields={fields}
                    includedFields={includedFields}
                    uniqueKey={docId ? docId : '-1'}
                    docScheme={scheme}
                    ensureExternalDataSourceLoaded={ensureExternalDataSourceLoaded}
                    documentCard
                />
                <ScrollToTop scrollElementRef={documentTabRef} behavior={'smooth'} />
            </div>
        </DocumentFormulaTraceParentContext>
    );
};

export default DocumentTabItem;
